import { Card, Flex, Typography } from 'antd';
import {
  PreSalesCancellationReason,
  PreSalesQuestion,
} from '../../../dto/model';
import { strings } from '../../../lang';
import { PreSalesAnswers } from '../../../utils/pre-sales-questionnaire-evaluator';
import { PreSalesLiveHeatLoadStatus } from './pre-sales-live-heat-load-status';

const { Text } = Typography;

type PreSalesHeatLoadCardProps = {
  answers: PreSalesAnswers;
  visibleQuestions: PreSalesQuestion[];
  cancellationReasons: PreSalesCancellationReason[];
};

export const isPreSalesLiveHeatLoadCancellation = (
  cancellationReasons: PreSalesCancellationReason[],
): boolean => cancellationReasons.some(
  (reason) => reason.product === 'WP' && reason.questionKeys.includes('liveHeatLoad'),
);

export const PreSalesHeatLoadCard = ({
  answers,
  visibleQuestions,
  cancellationReasons,
}: PreSalesHeatLoadCardProps) => {
  const isLiveHeatLoadCancellation = isPreSalesLiveHeatLoadCancellation(cancellationReasons);

  return (
    <Card
      aria-labelledby="bp-presales-heat-load-title"
      size="small"
    >
      <Flex vertical gap={8}>
        <Text
          id="bp-presales-heat-load-title"
          strong
          style={{ margin: 0 }}
          type="secondary"
        >
          {strings.preSalesQuestionnaire.heatLoadLabel.toUpperCase()}
        </Text>
        <PreSalesLiveHeatLoadStatus
          answers={answers}
          visibleQuestions={visibleQuestions}
          isLiveHeatLoadCancellation={isLiveHeatLoadCancellation}
        />
      </Flex>
    </Card>
  );
};
